import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    // Skip scroll to top when hash present (anchors) or language switch requested it
    if (location.state && location.state.skipScroll) return;
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [location.pathname, location.state, location.hash]);
  return null;
}
